import { accessoryFragment } from '@features/accessory-categories/queries';
import { AccessoryEntrance } from '@features/accessory-categories/types';
import { readFragment } from 'src/graphql';

export function getAccessoryCategoryProductIds(accessories: AccessoryEntrance[] | null) {
  if (accessories === null) return [];

  return accessories
    .map(accessory => readFragment(accessoryFragment, accessory.fragment).product?.id)
    .filter(id => id !== undefined);
}
